<mat-horizontal-stepper orientation="horizontal" [linear]="isLinear" #stepper *ngIf="!disableMatPanelValue">
    <mat-step [stepControl]="analysisFormGroup">

        <ng-template matStepLabel>
            <div (click)="editform()">
                Fill out Analysis Details
            </div>
        </ng-template>

        <card class="mb-0">
            <div class="container" *ngIf="!post;">
                <form [formGroup]="analysisFormGroup" novalidate>
                    <div class="row">
                        <div class="col-md-10 my-1">
                            <mat-form-field>
                                <mat-select placeholder="Analysis Type" formControlName="analysisType" data-cy="analysis-type-select"
                                    (ngModelChange)="resetAnalysis($event)" required disableOptionCentering>
                                    <mat-option *ngFor="let obj of modules" [value]="obj.name">
                                        {{obj.desc}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div *ngIf="analysisFormGroup.value.analysisType === 'AP'">
                        <app-ap-report [analysistype]="analysisFormGroup.value.analysisType" [editvalues]="editDetails"
                            (formvalue)=" displaydetails($event)"></app-ap-report>
                    </div>
                    <div *ngIf="analysisFormGroup.value.analysisType === 'qPCR'">
                        <app-qpcr-report [analysistype]="analysisFormGroup.value.analysisType" data-cy="qpcr-report"
                            [editvalues]="editDetails" (formvalue)=" displaydetails($event)"> </app-qpcr-report>
                    </div>
                </form>
                <br>
                <br><br>
            </div>
        </card>
    </mat-step>


    <mat-step>
        <ng-template matStepLabel>
            <div *ngIf="!openSecondMatStep">
                Upload File
            </div>
            <div *ngIf="openSecondMatStep" (click)='editdetails(analysisDetails)'>
                Upload File
            </div>
        </ng-template>
        <ng-template [ngIf]=" post">

            <button class="btn btn-warning" style="float: right;" (click)="editform()" matStepperPrevious>Edit
                Analysis
                Details</button>

            <div *ngIf="analysisDetails.analysisType==='qPCR'">
                <div class="col-md-8"><strong>Analysis Type:</strong>
                    {{getDisplayString(analysisDetails.analysisType)}}
                </div>
                <div class="col-md-8"><strong>Project Code:</strong>
                    {{analysisDetails.projectCode}}
                </div>
                <div class="col-md-8"><strong> Study:</strong>
                    {{getDisplayString(analysisDetails.study)}}
                </div>
                <div class="col-md-8"><strong>Target Names</strong></div>
                <mat-accordion class="grid-container">
                    <div *ngFor="let target of analysisDetails.TargetNames; let i = index" class="grid-item">

                        <mat-expansion-panel style="margin-bottom: 20px;">
                            <mat-expansion-panel-header>
                                <mat-panel-title><strong>Target Name:
                                        {{target.targetName }}</strong></mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="grid-content">
                                <div><strong>Target Type:</strong>
                                    {{ getDisplayString(target.TargetType) }}
                                </div>
                                <!-- <div><strong>Target Name:</strong>
                                    {{ target.targetName }}
                                </div> -->
                            </div>
                            <div *ngIf="target.TargetType === 'QL'" class="grid-content">
                                <div><strong>Negative Reverse Transcriptase Control Sample
                                        Included:</strong>
                                    {{ target.QL.QLRTsamples === 'True' ? 'Yes':'No'}}
                                </div>
                                <div><strong>Intra %CV Threshold of Replicate Ct Values:</strong>
                                    {{ target.QL.Intra_percent_CV}}
                                </div>
                                <div>
                                    <strong>%CV Threshold of Housekeeping and Test Sample Ct
                                        Values:</strong>{{target.QL.Threshold_CV}}
                                </div>
                            </div>

                            <div *ngIf="target.TargetType === 'QT'" class="grid-content">
                                <div><strong>Negative Reverse Transcriptase Control Sample
                                        Included:</strong>
                                    {{ target.QT.QTRTsamples === 'True' ? 'Yes':'No'}}
                                </div>
                                <div *ngIf="target.QT?.contaminationThreshold !== null"><strong> %Contamination Threshold:</strong>
                                    {{ getDisplayString(target.QT.contaminationThreshold) }}
                                </div>
                                <div><strong> Spiked Samples Used:</strong>
                                    {{ target.QT?.SpikeSamples ==='True' ? 'Yes':'No' }}
                                </div>
                                <div *ngIf="target.QT?.spikeCopies !== null"><strong>Number of Spiked Copies:</strong>
                                    {{ target.QT?.spikeCopies }}
                                </div>
                                <div *ngIf="target.QT?.recoveryThreshold !== null"><strong>%Recovery Threshold:</strong>
                                    {{ getDisplayString(target.QT.recoveryThreshold) }}
                                </div>
                                <div><strong>Inhibition Samples Used:</strong>
                                    {{ target.QT.InhibitionSamples ==='True' ? 'Yes':'No'}}
                                </div>
                                <div *ngIf="target.QT?.spikeCopies2 !== null"><strong> Number of Spiked Copies if Inhibition Samples
                                        Used:</strong>
                                    {{ target.QT?.spikeCopies2 }}
                                </div>
                                <div><strong>General Inter Precision %CV for Back Calculated
                                        Value:</strong>
                                    {{target.QT.Gen_Inter_prec_CV_Back_Calc}}
                                </div>
                                <div><strong>LLOQ/ULOQ Inter Precision %CV for Back Calculated
                                        Value:</strong>
                                    {{target.QT.LLOQ_ULOQ_Inter_prec_CV_Back_Calc}}
                                </div>

                                <div><strong>General Intra and Inter Accuracy %RE for Back
                                        Calculated
                                        Value:</strong>
                                    {{target.QT.Gen_Intra_Inter_Acc_RE_Back_Calc}}
                                </div>
                                <div><strong>LLOQ/ULOQ Inter and Intra Accuracy %RE for Back
                                        Calculated
                                        Value:</strong>
                                    {{target.QT.ULOQ_LLOQ_Inter_Intra_RE_Back_Calc}}
                                </div>
                                <div><strong>Lower Slope Value:</strong>
                                    {{target.QT.Lower_Slope_Value}}
                                </div>

                                <div><strong>Higher Slope Value:</strong>
                                    {{target.QT.Higher_Slope_Value}}
                                </div>

                                <div *ngIf="target.QT?.Cq.Intra_prec_CV_Cq !== null"><strong>Intra Precision %CV for Ct Value:</strong>
                                    {{target.QT.Cq.Intra_prec_CV_Cq}}
                                </div>

                                <div *ngIf="target.QT?.BackCalculated.Gen_Intra_prec_CV_Back_Calc !== null"><strong>General Intra Precision %CV for Back Calculated
                                        Value:</strong>
                                    {{target.QT.BackCalculated.Gen_Intra_prec_CV_Back_Calc}}
                                </div>
                                <div *ngIf="target.QT?.BackCalculated.LLOQ_ULOQ_Intra_prec_CV_Back_Calc !== null"><strong>LLOQ/ULOQ Intra Precision %CV for Back Calculated
                                        Value:</strong>
                                    {{target.QT.BackCalculated.LLOQ_ULOQ_Intra_prec_CV_Back_Calc}}
                                </div>

                                <div><strong>True LLOQ Nominal Value:</strong>
                                    {{target.QT.QualityControls.LLOQ_QC}}
                                </div>
                                <div><strong>Low QC Nominal Value:</strong>
                                    {{target.QT.QualityControls.Low_QC}}
                                </div>
                                <div><strong>Mid QC Nominal Value:</strong>
                                    {{target.QT.QualityControls.Mid_QC}}
                                </div>
                                <div><strong>High QC Nominal Value:</strong>
                                    {{target.QT.QualityControls.High_QC}}
                                </div>
                                <div><strong>True ULOQ Nominal Value:</strong>
                                    {{target.QT.QualityControls.ULOQ_QC}}
                                </div>
                            </div>
                        </mat-expansion-panel>


                    </div>
                </mat-accordion>

            </div>

            <div *ngIf="analysisDetails.analysisType=='AP'">
                <div class="row">
                    <div class="col-md-6">
                        <strong>Analysis Type:</strong>
                        {{getDisplayString(analysisDetails.analysisType)}}
                    </div>
                </div>
                <div>
                    <div class="col-md-6"><strong>Regression Type:</strong>{{getDisplayString(analysisDetails.analysisSubtype)}}</div>
                    <div class="col-md-6"><strong>Analyte Name: </strong>{{analysisDetails.analyteNames}}</div>
                    <div class="col-md-6"><strong>Project Code:</strong> {{analysisDetails.projectCode}}</div>
                </div>
            </div>

        </ng-template>
    </mat-step>
</mat-horizontal-stepper>


<div *ngIf="disableMatPanelValue">

    <div *ngIf="analysisDetails.analysisType==='qPCR'">
        <div class="col-md-6"><strong>Analysis Type:</strong>
            {{getDisplayString(analysisDetails.analysisType)}}
        </div>
        <div class="col-md-6"><strong> Project Code:</strong>
            {{analysisDetails.projectCode}}
        </div>
        <div class="col-md-6"><strong> Study:</strong>
            {{getDisplayString(analysisDetails.study)}}
        </div>
        <div class="col-md-8"><strong>Target Names</strong></div>
        <mat-accordion class="grid-container">
            <div *ngFor="let target of analysisDetails.TargetNames; let i = index" class="grid-item">

                <mat-expansion-panel style="margin-bottom: 20px;">
                    <mat-expansion-panel-header>
                        <mat-panel-title><strong>Target Name:
                                {{target.targetName }}</strong></mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="grid-content">
                        <div><strong>Target Type:</strong>
                            {{ getDisplayString(target.TargetType) }}
                        </div>
                        <!-- <div><strong>Target Name:</strong>
                            {{ target.targetName }}
                        </div> -->
                    </div>


                    <div *ngIf="target.TargetType === 'QL'" class="grid-content">
                        <div><strong>Negative Reverse Transcriptase Control Sample
                                Included:</strong>
                            {{ target.QL.QLRTsamples === 'True' ? 'Yes':'No'}}
                        </div>
                        <div><strong>Intra %CV Threshold of Replicate Ct Values:</strong>
                            {{ target.QL.Intra_percent_CV}}
                        </div>
                        <div>
                            <strong>%CV Threshold of Housekeeping and Test Sample Ct
                                Values:</strong>{{target.QL.Threshold_CV}}
                        </div>
                    </div>

                    <div *ngIf="target.TargetType === 'QT'" class="grid-content">
                        <div><strong>Negative Reverse Transcriptase Control Sample
                                Included:</strong>
                            {{ target.QT.QTRTsamples === 'True' ? 'Yes':'No'}}
                        </div>
                        <div *ngIf="target.QT?.contaminationThreshold !== null"><strong> %Contamination Threshold:</strong>
                            {{ getDisplayString(target.QT.contaminationThreshold) }}
                        </div>
                        <div><strong> Spiked Samples Used:</strong>
                            {{ target.QT?.SpikeSamples ==='True' ? 'Yes':'No' }}
                        </div>
                        <div *ngIf="target.QT?.spikeCopies !== null"><strong>Number of Spiked Copies:</strong>
                            {{ target.QT?.spikeCopies }}
                        </div>
                        <div *ngIf="target.QT?.recoveryThreshold !== null"><strong>%Recovery Threshold:</strong>
                            {{ getDisplayString(target.QT.recoveryThreshold) }}
                        </div>
                        <div><strong>Inhibition Samples Used:</strong>
                            {{ target.QT.InhibitionSamples ==='True' ? 'Yes':'No'}}
                        </div>
                        <div *ngIf="target.QT?.spikeCopies2 !== null"><strong> Number of Spiked Copies if Inhibition Samples
                                Used:</strong>
                            {{ target.QT?.spikeCopies2 }}
                        </div>
                        <div><strong>General Inter Precision %CV for Back Calculated
                                Value:</strong>
                            {{target.QT.Gen_Inter_prec_CV_Back_Calc}}
                        </div>
                        <div><strong>LLOQ/ULOQ Inter Precision %CV for Back Calculated
                                Value:</strong>
                            {{target.QT.LLOQ_ULOQ_Inter_prec_CV_Back_Calc}}
                        </div>

                        <div><strong>General Intra and Inter Accuracy %RE for Back
                                Calculated
                                Value:</strong>
                            {{target.QT.Gen_Intra_Inter_Acc_RE_Back_Calc}}
                        </div>
                        <div><strong>LLOQ/ULOQ Inter and Intra Accuracy %RE for Back
                                Calculated
                                Value:</strong>
                            {{target.QT.ULOQ_LLOQ_Inter_Intra_RE_Back_Calc}}
                        </div>
                        <div><strong>Lower Slope Value:</strong>
                            {{target.QT.Lower_Slope_Value}}
                        </div>

                        <div><strong>Higher Slope Value:</strong>
                            {{target.QT.Higher_Slope_Value}}
                        </div>

                        <div *ngIf="target.QT?.Cq.Intra_prec_CV_Cq !== null"><strong>Intra Precision %CV for Ct Value:</strong>
                            {{target.QT.Cq.Intra_prec_CV_Cq}}
                        </div>

                        <div *ngIf="target.QT?.BackCalculated.Gen_Intra_prec_CV_Back_Calc !== null"><strong>General Intra Precision %CV for Back Calculated
                                Value:</strong>
                            {{target.QT.BackCalculated.Gen_Intra_prec_CV_Back_Calc}}
                        </div>
                        <div *ngIf="target.QT?.BackCalculated.LLOQ_ULOQ_Intra_prec_CV_Back_Calc !== null"><strong>LLOQ/ULOQ Intra Precision %CV for Back Calculated
                                Value:</strong>
                            {{target.QT.BackCalculated.LLOQ_ULOQ_Intra_prec_CV_Back_Calc}}
                        </div>

                        <div><strong>True LLOQ Nominal Value:</strong>
                            {{target.QT.QualityControls.LLOQ_QC}}
                        </div>
                        <div><strong>Low QC Nominal Value:</strong>
                            {{target.QT.QualityControls.Low_QC}}
                        </div>
                        <div><strong>Mid QC Nominal Value:</strong>
                            {{target.QT.QualityControls.Mid_QC}}
                        </div>
                        <div><strong>High QC Nominal Value:</strong>
                            {{target.QT.QualityControls.High_QC}}
                        </div>
                        <div><strong>True ULOQ Nominal Value:</strong>
                            {{target.QT.QualityControls.ULOQ_QC}}
                        </div>
                    </div>
                </mat-expansion-panel>


            </div>
        </mat-accordion>

    </div>
    <div *ngIf="analysisDetails.analysisType=='AP'">
        <div class="row">
            <div class="col-md-6">
                <strong>Analysis Type:</strong>
                {{getDisplayString(analysisDetails.analysisType)}}
            </div>
        </div>
        <div>
            <div class="col-md-6"><strong>Regression Type:</strong> {{getDisplayString(analysisDetails.analysisSubtype)}}</div>
            <div class="col-md-6"><strong>Analyte Name: </strong>{{analysisDetails.analyteNames}}</div>
            <div class="col-md-6"><strong>Project Code:</strong> {{analysisDetails.projectCode}}</div>
        </div>
    </div>
</div>

<ng-template [ngIf]=" post">
    <app-doc-upload [analysisDetails]="analysisDetails" (matPanel)="disableMatPanel($event)"></app-doc-upload>
</ng-template>